import { z } from "zod";

import { imageFormatSchema } from "api/schemas/imageCollectionApiSchema";
import { signalSchema } from "api/schemas/signalsApiSchema";
import { topicSchema } from "api/schemas/topicsApiSchema";
import { nullToUndefined } from "api/utils";
import { LanguageCode } from "common/types/languageCode";
import { ContentType } from "entities/knowledge/types";

const attachmentSchema = z.object({
  id: z.string(),
  image_url: z.string().optional(),
  type: z.string(),
  url: z.string(),
});

const contentTypeSchema = z.nativeEnum(ContentType);

const languageCodeSchema = z.nativeEnum(LanguageCode);

const embeddedMediaSchema = z.object({
  height: z.number().optional(),
  html: nullToUndefined(z.string()),
  title: nullToUndefined(z.string()),
  width: z.number().optional(),
  url: z.string().optional(),
});

export const sourceSchema = z.object({
  content_type: nullToUndefined(contentTypeSchema),
  id: nullToUndefined(z.string()),
  images: nullToUndefined(imageFormatSchema),
  name: z.string(),
});

export const knowledgeSchema = z.object({
  attachment: nullToUndefined(attachmentSchema),
  authors: z.array(z.string()).default([]).optional(),
  created_at: z.string().nullish(),
  embedded_media: nullToUndefined(embeddedMediaSchema),
  language: languageCodeSchema,
  link: z.string(),
  id: z.string(),
  image: z.string().optional(),
  images: nullToUndefined(imageFormatSchema),
  interactive_link: nullToUndefined(z.string()),
  is_bookmarked: z.boolean().optional(),
  is_pinned: nullToUndefined(z.boolean()),
  publisher: z.string(),
  signals: z.array(signalSchema).optional(),
  source: sourceSchema,
  status: nullToUndefined(z.string()),
  summary: z.string(),
  time: z.number(),
  time_bookmarked: z.number().optional(),
  title: z.string(),
  topics: z.array(topicSchema),
  type: z.literal("article"),
});
